export const getAccount = (accountsList, accountRefID, type) => {
  const account =
    accountsList && accountsList.find((account) => account.ObjectMeta.ID === accountRefID)
  return type === 'name' ? account?.ObjectMeta?.Name : account?.Spec?.Type
}
